import { useEffect, useMemo } from 'react';
import { useColorContext } from '../contexts/ColorContext';
import { ColorEncyclopediaPanel } from '../components/ColorEncyclopediaPanel';
import { colorEngine } from '../lib/colorEngine';
import { useColorActions } from '../hooks/useColorActions';
import { useToolInit } from '../hooks/useToolInit';

export function EncyclopediaTool() {
  const { displayResult, setInput, copiedField, copyToClipboard } = useColorContext();
  const { setActiveColor, saveToFavorites } = useColorActions();
  const { params } = useToolInit();

  // Deep-link: ?color= sets global active color
  useEffect(() => {
    if (params.color) setInput(params.color);
  }, [params.color, setInput]);

  const encyclopediaData = useMemo(() => {
    if (!displayResult) return null;
    return colorEngine.generateColorEncyclopedia(displayResult.hex, displayResult);
  }, [displayResult]);

  if (!displayResult) {
    return <div style={{ padding: '48px 0', textAlign: 'center', color: 'var(--ink-3)', fontSize: 13 }}>Enter a valid color to explore.</div>;
  }

  return (
    <ColorEncyclopediaPanel
      data={encyclopediaData}
      copiedField={copiedField}
      onCopy={copyToClipboard}
      onSetActive={(hex) => setActiveColor({ hex })}
      onSave={saveToFavorites}
    />
  );
}
